/*eslint-disable*/
import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-pro-react/components/headerLinksStyle.js";
import { APP_STRINGS } from "constants/appStrings";

const useStyles = makeStyles(styles);

export default function HeaderLinks({ rollPageOnClickButton }) {
  const classes = useStyles();

  const handleWhatsapp = () => {
    window.open(APP_STRINGS.links.whatsapp, "_blank");
  };

  return (
    <List className={classes.list}>
      {APP_STRINGS.navigation.items.map((item) => (
        <ListItem className={classes.listItem} key={item.id}>
          <Button
            className={classes.navLink}
            color="transparent"
            onClick={() => rollPageOnClickButton(item.id)}
          >
            {item.label}
          </Button>
        </ListItem>
      ))}

      <ListItem className={classes.listItem}>
        <Button className={classes.navLink} color="transparent" href="/login">
          Area do cliente
        </Button>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-tooltip"
          title={APP_STRINGS.navigation.instagramTooltip}
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href={APP_STRINGS.links.instagram}
            target="_blank"
            className={classes.socialButton}
          >
            <i className={"fab fa-instagram " + classes.socialIcons} />
          </Button>
        </Tooltip>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Tooltip
          id="whatsapp-tooltip"
          title={APP_STRINGS.navigation.whatsappTooltip}
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            onClick={handleWhatsapp}
            rel="noopener noreferrer"
            className={classes.socialButton}
          >
            <i className={"fab fa-whatsapp " + classes.socialIcons} />
          </Button>
        </Tooltip>
      </ListItem>
    </List>
  );
}

